/**
 * Created by Administrador on 16/11/2017.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('classifications', {
                parent: 'app',
                url: '/classifications?page&size',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configCargo/adminClassification/classification/classifications.html',
                        controller: 'classificationCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabs': ['tabService', function (tabService) {
                                return tabService.getTabAdminClassifications('classifications')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['classification']);
                            }],
                            classifications: ['classificationService', '$stateParams', function (classificationService, $stateParams) {
                                return classificationService.getClassifications($stateParams.page, $stateParams.size);
                            }]
                        }
                    }
                }
            })
            .state('classificationNew', {
                parent: 'app',
                url: '/classification/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configCargo/adminClassification/classification/newClassification.html',
                        controller: 'newEditClassificationCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabAdminClassifications('classifications')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['classification']);
                            }],
                            action: [function () {
                                return "new";
                            }],
                            classification: [function () {
                                return null;
                            }]
                        }
                    }
                }
            })
            .state('classificationEdit', {
                parent: 'app',
                url: '/classification/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configCargo/adminClassification/classification/editClassification.html',
                        controller: 'newEditClassificationCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabAdminClassifications('classifications')
                            }],
                            classification: ['classificationService', '$stateParams', function (classificationService, $stateParams) {
                                return classificationService.getClassification($stateParams.id)
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['classification']);
                            }],
                            action: [function () {
                                return "edit";
                            }],
                        }
                    }
                }
            })
            .state('classificationDelete', {
                parent: 'classifications',
                url: '/classification/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configCargo/adminClassification/classification/deleteClassification.html',
                        controller: 'deleteClassificationCtrl',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            classification: ['classificationService', function (classificationService) {
                                return classificationService.getClassification($stateParams.id)
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['classification']);
                            }]
                        }
                    }).result.then(function () {
                        $state.go('classifications', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();
